import { Calendar } from "lucide-react";
import { cn } from "../../../../utils/utils";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../../../../components/UI/Popover";
import { DATE_PRESETS } from "./dateRange";

const DateRangeSelector = ({
  datePreset,
  setDatePreset,
  customRange,
  setCustomRange,
}) => (
  <div className="inline-flex items-center rounded-md border border-gray-200 bg-white p-0.5 gap-0.5">
    {DATE_PRESETS.map((p) => (
      <button
        key={p.value}
        type="button"
        onClick={() => setDatePreset(p.value)}
        className={cn(
          "px-2.5 py-1 text-xs font-medium rounded transition-colors",
          datePreset === p.value
            ? "bg-indigo-600 text-white"
            : "text-gray-600 hover:bg-gray-100",
        )}
      >
        {p.label}
      </button>
    ))}
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className={cn(
            "px-2.5 py-1 text-xs font-medium rounded transition-colors inline-flex items-center gap-1",
            datePreset === "custom"
              ? "bg-indigo-600 text-white"
              : "text-gray-600 hover:bg-gray-100",
          )}
        >
          <Calendar size={11} />
          Tùy chỉnh
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-3" align="start">
        <div className="space-y-2">
          <label className="block text-xs font-medium text-gray-600">
            Từ ngày
            <input
              type="date"
              value={customRange.dateFrom}
              onChange={(e) =>
                setCustomRange((r) => ({ ...r, dateFrom: e.target.value }))
              }
              className="mt-1 w-full px-2 py-1.5 text-sm rounded border border-gray-200"
            />
          </label>
          <label className="block text-xs font-medium text-gray-600">
            Đến ngày
            <input
              type="date"
              value={customRange.dateTo}
              onChange={(e) =>
                setCustomRange((r) => ({ ...r, dateTo: e.target.value }))
              }
              className="mt-1 w-full px-2 py-1.5 text-sm rounded border border-gray-200"
            />
          </label>
          <button
            type="button"
            onClick={() => setDatePreset("custom")}
            disabled={!customRange.dateFrom && !customRange.dateTo}
            className="w-full px-3 py-1.5 text-xs font-medium text-white bg-indigo-600 rounded hover:bg-indigo-700 disabled:opacity-50"
          >
            Áp dụng
          </button>
        </div>
      </PopoverContent>
    </Popover>
  </div>
);

export default DateRangeSelector;
